import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TabDataService {
  baseUrl = environment.url;
  constructor(private http: HttpClient) {}

  
  fetchData({
    status,
    technician_id,
    page,
    size,
    city_identifier
  }:{
    status:string,
    technician_id:string,
    page:number,
    size:number,
    city_identifier?:string
  }): Observable<any[]> {
    const cityParam = city_identifier ? `&city_identifier=${city_identifier}` : '';
    let url = (status === 'all') ? `${this.baseUrl}/get-services-details?technician_id=${technician_id}&size=${size}&page=${page}${cityParam}` : `${this.baseUrl}/get-services-details?status=${status}&technician_id=${technician_id}&size=${size}&page=${page}${cityParam}`;
    return this.http.get<any[]>(url);
  }

  getAreaMappings(city_identifier: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/get-area-mappings?identifier=${city_identifier}`);
  }

  getCities(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/get-city-details`);
  }
}
